module.exports = __webpack_public_path__ + "img/chuxin.99a185fe.png";